<template>
  <div :class="classes">
      <pt-page-title title="系统用户" isSearch  @search="search" @emptySearch="emptySearch" placeholder="请输入用户姓名搜索" :searchKey="searchKey" @searchNo="searchNo" isParams>
          <template slot="before-left">
              <el-button type="primary" @click="createCustomer">新建用户</el-button>
          </template>
      </pt-page-title>
      <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-system-customer-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" :class="$style['pt-system-customer-table']" ref="tabele" :paramsData="paramsData">
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <i class="iconfont icon-bianji" @click="editCustomer(scope.row)"></i>
                  <i class="iconfont icon-shanchu" @click="deleteCustomer(scope.row)"></i>
              </template>
          </el-table-column>
      </pt-system-customer-table>
  </div>
</template>

<script>
// 组件class前缀
import { systemTableFilter, systemTableLabels } from './system-customer-option'
import ptSystemCustomerTable from './pt-system-customer-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-customer-of-system'
export default {
  name: 'pt-customer-of-system',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.tabele.page
    }
  },
  components: {
    ptSystemCustomerTable
  },
  props: {
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      filterLabels: systemTableFilter,
      tableLabels: systemTableLabels,
      params: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: null
    }
  },
  watch: {
    rolesList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'role') {
            item.options = val
          }
        })
      }
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = { username: val }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsData, 'username')
    },
    searchNo (val) {
      this.searchKey = val
    },
    getTableData (page) {
      console.log('page', page)
      this.$refs.tabele.getTableData(page)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      console.log('this.isFromRouter', this.isFromRouter)
      this.paramsData = { ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      for (var key1 in this.params) {
        this.$delete(this.params, key1)
      }
    },
    editCustomer (val) {
      this.$router.push('/customer-of-system/system-customer-form/true/' + val.userLogin)
    },
    deleteCustomer (val) {
      this.$confirm('您确定删除该系统用户吗？', '删除系统用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('deleteCustomer', val.userLogin)
      }).catch(_ => {

      })
    },
    createCustomer () {
      this.$router.push('/customer-of-system/system-customer-form/false/0')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-system-customer-table{
    :global
  .iconfont{
        margin-right: 10px;
    }
}

</style>
